import { render, staticRenderFns } from "./RiderInformation.vue?vue&type=template&id=503a6212&scoped=true"
import script from "./RiderInformation.vue?vue&type=script&lang=js"
export * from "./RiderInformation.vue?vue&type=script&lang=js"
import style0 from "./RiderInformation.vue?vue&type=style&index=0&id=503a6212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503a6212",
  null
  
)

export default component.exports